import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const TAB_YOURE_IT_ACTIVITY_FRAGMENT = gql `
  fragment TabYoureItActivityFragment on TabYoureItActivity {
    rounds {
      steps {
        answer
        column
        id
        activityAudio: optionalAudio {
          audio {
            ...AssetFragment
          }
        }
        activityImage: optionalImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default TAB_YOURE_IT_ACTIVITY_FRAGMENT;
